export interface CustomField extends NamedIdentity {
  areaType: string;
  type: string;
  position: number;
  height: number;
  required: boolean;
  private: boolean;
  hidden: boolean;
  decimals: string;
  formula: string;
  invalid: boolean;
  formulaFieldOptions: Option[];
  formulaFields: number[];
  choices: CustomFieldDropdownChoice[];
  resourceType: NamedIdentity;
  relationshipType: NamedIdentity;
  copy?: boolean;
}

export interface CustomFieldDropdownChoice extends NamedIdentity {
  position: number;
}

export class Option {
  constructor(
    public id: number,
    public name: string,
    public customFieldId: string) {
  }
}

export interface NamedIdentity {
  id: number;
  name: string;
  displayName?: string;
  fileBaseType?: string;
  distributionType?: string;
}

export class CustomFieldConstants {
  static nativeField = 'native_field';
  static customField = 'custom_field';
  static associationField = 'association_field';
  static image = 'image';
  static text = 'text';
  static date = 'date';
  static numeric = 'numeric';
  static encryptedText = 'enc_text';
  static chechbox = 'chechbox';
  static checkbox = 'checkbox';
  static radio = 'radio';
  static picklist = 'picklist';
  static multiselect = 'multiselect';
  static textBox = 'textbox';
  static formula = 'formula';
}
